import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ReusableDatePicker from "../../Calendar/Reusable/ReusableDatePicker"
import { useSelector } from "react-redux"
import dayjs from "dayjs"
import StyledDropdown from "./StyledDropdown"

//!

type formDialogProps = {
  open: boolean
  closeHandler: () => void
  createHandler?: any
  updateHandler?: any
}

export type formType = {
  label: string
  key?: string
  type?: "text" | "number"
  originalValue?: number | string
  value: number | string | null
  placeHolder: string
  required?: boolean
  componentType: -1 | 0 | 1 | 2 | 3 | 4
  props?: any
  options?: string[]
  error: boolean
  validation?: {
    min: number
    max: number
  }
  errorMessage?: string
  dependent?: boolean
  disabled?: boolean
}

export const CreateFormDialog = (props: formDialogProps) => {
  const { open, closeHandler, createHandler } = props

  const doctorList: any = useSelector(
    (state: any) => state.doctorCompensation.doctorList,
  )

  const [guarantee, setGuarantee] = useState<boolean>(false)

  const formFields: formType[] = [
    {
      label: "Doctor Name",
      key: "provider_name",
      placeHolder: "Doctor Name",
      componentType: 2,
      options: doctorList,
      value: "Select doctor",
      required: true,
      props: {
        autoFocus: true,
      },
      error: false,
    },
    {
      label: "Doctor Comp Plan",
      key: "comp_plan_type",
      placeHolder: "Doctor Comp Plan",
      componentType: 2,
      options: [
        "Net Production",
        "Gross Production",
        "Collections",
        "Flat Salary",
      ],
      value: "Select comp plan",
      required: true,
      error: false,
    },
    {
      label: "Memo",
      key: "qbo_memo",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "Compensation Account",
      key: "compensation_account",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "Bonus Account",
      key: "bonus_account",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "",
      key: "_",
      type: "text",
      placeHolder: "",
      componentType: 0,
      value: "",
      required: false,
      error: false,
    },
    {
      label: "Comp Plan Start Date",
      key: "plan_start_date",
      value: "",
      placeHolder: "",
      componentType: 3,
      required: true,
      error: false,
    },
    {
      label: "Comp Plan End Date",
      key: "plan_end_date",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 3,
      required: true,
      error: false,
    },
    {
      label: "Guarantee",
      key: "guarantee_yes_no",
      placeHolder: "No",
      componentType: 2,
      required: true,
      value: "No",
      options: ["No", "Yes"],
      error: false,
    },
    {
      label: "Guarantee Type",
      key: "guarantee_type",
      placeHolder: "No",
      componentType: 2,
      required: guarantee ? true : false,
      value: "Select guarantee type",
      options: ["Daily", "Monthly"],
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee Start Date",
      key: "guarantee_start_date",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 3,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee End Date",
      key: "guarantee_end_date",
      type: "text",
      value: "",
      placeHolder: "",
      componentType: 3,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee $",
      key: "guarantee_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Commission When Over Guarantee",
      key: "commission_over_guarantee_yes_no",
      placeHolder: "No",
      componentType: 2,
      required: guarantee ? true : false,
      value: "No",
      options: [`No`, `Yes`],
      error: false,
      dependent: true,
    },
    {
      label: "Lab %",
      key: "lab_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: true,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: "",
      key: "_",
      type: "text",
      placeHolder: "",
      componentType: -1,
      value: "",
      required: false,
      error: false,
    },
    {
      label: `Tier 1 %`,
      key: "tier_1_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: true,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 1 $`,
      key: "tier_1_comp_max_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: `Tier 2 %`,
      key: "tier_2_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 2 $`,
      key: "tier_2_comp_max_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 3 %`,
      key: "tier_3_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 3 $`,
      key: "tier_3_comp_max_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 4 %`,
      key: "tier_4_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 4 $`,
      key: "tier_4_comp_max_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 5 %`,
      key: "tier_5_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      value: "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 5 $`,
      key: "tier_5_comp_max_amount",
      type: "text",
      value: "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
  ]

  const [loading, setLoading] = useState<boolean>(false)
  const [formState, setformState] = useState(formFields)
  const [guaranteeStartDate, setGuaranteeStartDate] = useState<any>(null)
  const [guaranteeEndDate, setGuaranteeEndDate] = useState<any>(null)

  useEffect(() => {
    setGuaranteeStartDate(
      formState?.find((f: formType) => f.key == "plan_start_date")?.value,
    )
    setGuaranteeEndDate(
      formState?.find((f: formType) => f.key == "plan_end_date")?.value,
    )
  }, [formState])

  //! Stashed

  // const [tierNumber, setTierNumber] = useState<number>(1)
  // const addATier = () => {
  //   const Tier: formType[] = [
  //     {
  //       label: `Tier ${tierNumber} %`,
  //       type: "number",
  //       placeHolder: "0 - 100",
  //       componentType: 1,
  //       value: 0,
  //       error: false,
  //       validation: {
  //         min: 0,
  //         max: 100,
  //       },
  //     },
  //     {
  //       label: `Tier ${tierNumber} $`,
  //       type: "text",
  //       value: "",
  //       placeHolder: "",
  //       componentType: 1,
  //       required: false,
  //       error: false,
  //     },
  //   ]

  //   setformState([...formState, ...Tier])
  //   setTierNumber((num) => num + 1)
  // }
  // const removeATier = () => {
  //   if (tierNumber > 1) {
  //     formState.pop()
  //     formState.pop()

  //     setTierNumber((num) => num - 1)
  //   }
  // }

  //! Stashed

  const submitHandler = async () => {
    let newFormState: formType[] = [...formState]
    let failed = false
    let guarantee_value: any = ""
    // Comp Plan - Guarantee Validation

    formState.forEach((field: formType) => {
      if (field.key == "guarantee_yes_no") {
        guarantee_value = field.value || ""
      }
    })

    formState.forEach((field: formType) => {
      if (field.key == "guarantee_yes_no") {
        const compPlanType = formState.find(
          (f: formType) => f?.key == "comp_plan_type",
        )

        if (compPlanType?.value == "Flat Salary" && !guarantee) {
          field.error = true
          field.errorMessage =
            "Guarantee must be Yes as Comp plan type is Flat Salary"
          failed = true
        } else {
          field.error = false
        }
      }
      if (field.key == "guarantee_amount") {
        if (guarantee_value == "Yes" && Number(field.value || 0) <= 0) {
          field.error = true
          field.errorMessage = "Guarantee amount must be greater than 0"
          failed = true
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Commission Over Guarantee - Tier 1 Validation

    formState.forEach((field: formType) => {
      if (
        field.key == "tier_1_comp_max_amount" ||
        field.key == "tier_1_comp_percent"
      ) {
        const commissionOverGuarantee = formState.find(
          (f: formType) => f?.key == "commission_over_guarantee_yes_no",
        )

        const fieldValue =
          field.key == "tier_1_comp_max_amount" &&
          field.value != null &&
          typeof field.value != "number"
            ? (parseFloat(field.value) as number)
            : (field.value as number)

        if (commissionOverGuarantee?.value == "Yes" && fieldValue <= 0) {
          field.error = true
          field.errorMessage =
            "Commission Over Guarantee is Yes, Tier 1 Values must be greater than 0"
          failed = true
        } else {
          field.error = false
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Guarantee Validation

    formState.forEach((field: formType) => {
      if (field.label.includes("Guarantee") && guarantee) {
        if (!field.value) {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        } else {
          field.error = false
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Default Selected Validation

    formState.forEach((field: formType) => {
      const fieldValue = field.value as string

      if (fieldValue?.includes("Select")) {
        if (!guarantee && field.label.includes("Guarantee")) {
          field.error = false
        } else {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        }
      } else {
        field.error = false
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Required Validation

    formState.forEach((field: formType) => {
      if (field.required && !field.value) {
        if (!guarantee && field.label.includes("Guarantee")) {
          field.error = false
        } else {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        }
      } else {
        field.error = false
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Number Range Validation

    newFormState.forEach((field) => {
      if (field.validation) {
        const fieldValue = field.value as number
        if (
          fieldValue < field.validation.min ||
          fieldValue > field.validation.max
        ) {
          failed = true
          field.error = true
          field.errorMessage = `Value should in between ${field.validation.min} and ${field.validation.max}`
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    // Date Validation
    let planStartDate = dayjs()
    let planEndDate = dayjs()
    let guaranteeStartDate = dayjs()
    let guaranteeEndDate = dayjs()

    newFormState.forEach((field) => {
      if (field.key == "plan_start_date") {
        planStartDate = dayjs(field.value)
      }
      if (field.key == "plan_end_date") {
        planEndDate = dayjs(field.value)
      }
      if (field.key == "guarantee_start_date") {
        guaranteeStartDate = dayjs(field.value)
      }
      if (field.key == "guarantee_end_date") {
        guaranteeEndDate = dayjs(field.value)
      }
    })

    newFormState.forEach((field) => {
      if (field.key == "plan_start_date" && planStartDate > planEndDate) {
        failed = true
        field.error = true
        field.errorMessage = `Plan Start date can not exceed End Date`
      }
      if (
        field.key == "guarantee_start_date" &&
        guaranteeStartDate > guaranteeEndDate
      ) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `Guarantee Start date can not exceed End Date`
        }
      }
      if (
        field.key == "guarantee_start_date" &&
        guaranteeStartDate < planStartDate
      ) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `Guarantee Start date can not be less than Plan Start Date`
        }
      }
      if (field.key == "guarantee_end_date" && guaranteeEndDate > planEndDate) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `Guarantee End date can not be more than Plan End Date`
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    // Tier Validation

    newFormState.forEach((field, index) => {
      if (field.label.includes("Tier") && field.label.includes("$")) {
        const fieldValue = field.value as string
        const fieldNumber = field.label.split(" ")[1]

        // console.log("field", field)
        // console.log("fieldValue", fieldValue)
        // console.log("fieldNumber", fieldNumber)

        if (parseInt(fieldNumber) > 1) {
          if (
            parseInt(fieldValue) > 0 &&
            parseInt(fieldValue) <
              parseInt(newFormState[index - 2].value as string)
          ) {
            failed = true
            field.error = true
            field.errorMessage = `Value should be larger than Tier ${
              parseInt(fieldNumber) - 1
            } $`
          }
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    setformState(newFormState)
    let payload: any = {}
    newFormState.forEach((field) => {
      const fieldName = field.key
        ? field.key
        : field.label.replaceAll(" ", "_").toLowerCase()
      if (!field.dependent) {
        payload[fieldName] = field.value
      } else {
        if (guarantee) payload[fieldName] = field.value
      }
    })
    const cleanUpHandler = (loadVal: boolean) => {
      if (!loadVal) {
        setformState([...formFields])
        setLoading(loadVal)
        setGuarantee(false)
        closeHandler()
        return
      }
      return setLoading(loadVal)
    }

    await createHandler(payload, cleanUpHandler)
  }

  const clearAndClose = () => {
    // setTierNumber(1)
    setformState(formFields)
    setGuarantee(false)
    closeHandler()
  }

  const fieldHandler = (e: any, index: number, ops?: any) => {
    if (ops?.componentType == 3) {
      const newState = [...formState]
      newState[index].value = e
      setformState(newState)
    } else {
      e.preventDefault()

      if (index == 8) {
        if (e.target.value == "Yes") setGuarantee(true)
        else setGuarantee(false)
      }

      const newState = [...formState]
      newState[index].value = e.target.value
      setformState(newState)
    }
  }

  const renderGrid = (ops: any, index: number) => {
    if (ops.componentType === 0) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Box></Box>
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === -1 && guarantee) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Box></Box>
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 1) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <TextField
            error={ops.error}
            key={ops.label}
            value={ops.value}
            onChange={(e) => fieldHandler(e, index)}
            required={ops?.required}
            placeholder={ops?.placeHolder}
            type={ops?.type}
            fullWidth
            variant="outlined"
          />
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 2) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <StyledDropdown ops={ops} fieldHandler={fieldHandler} index={index} />
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 3) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <ReusableDatePicker
            fieldHandler={fieldHandler}
            index={index}
            ops={ops}
            defaultValue={ops.value ? dayjs(ops.value) : ops.value}
            startDate={guaranteeStartDate}
            EndDate={guaranteeEndDate}
          />
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    }

    return null
  }

  useEffect(() => {}, [guarantee, formState, doctorList])

  return (
    <Dialog open={open} maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          my: 1,
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", pl: 2 }}>New contract</Typography>
        <IconButton sx={{ mr: 1 }} onClick={clearAndClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Grid container spacing={1.5} sx={{ px: 2, pb: 2, mt: "16px" }}>
        {formState.map((ops: formType, index: number) => {
          if (ops.dependent) {
            if (guarantee) {
              return renderGrid(ops, index)
            } else return null
          } else {
            return renderGrid(ops, index)
          }
        })}
      </Grid>
      {/* //! Stashed */}
      {/* <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          flex: 1,
          columnGap: 1,
          mb: 2,
          mx: 1,
          justifyContent: "space-between",
        }}
      >
        <Button onClick={addATier}> + Add Tier</Button>
        <Button color="error" onClick={removeATier}>
          - Remove Tier
        </Button>
      </Box> */}
      {/* //! Stashed */}
      <Box sx={{ display: "flex", flex: 1, columnGap: 1, mb: 2, mx: 2, my: 2 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={clearAndClose}
          sx={{ py: 1 }}
        >
          Cancel
        </Button>
        <Button
          endIcon={
            loading && <CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
          }
          variant="contained"
          fullWidth
          onClick={submitHandler}
          sx={{ py: 1 }}
        >
          {loading ? "Creating contract" : "Create contract"}
        </Button>
      </Box>
    </Dialog>
  )
}
export const UpdateFormDialog = (props: formDialogProps) => {
  const { open, closeHandler, updateHandler } = props

  const currentContract: any = useSelector(
    (state: any) => state.doctorCompensation.currentContract,
  )
  const doctorList: any = useSelector(
    (state: any) => state.doctorCompensation.doctorList,
  )

  const [guarantee, setGuarantee] = useState<boolean>(
    currentContract?.guarantee_yes_no
      ? currentContract?.guarantee_yes_no == "No"
        ? false
        : true
      : false,
  )

  const [reconciled, setReconciled] = useState<boolean>(
    currentContract?.is_reconciled,
  )

  const formFields: formType[] = [
    {
      label: "Doctor Name",
      key: "provider_name",
      placeHolder: "Doctor Name",
      componentType: 2,
      options: doctorList,
      originalValue: currentContract?.provider_name,
      value: currentContract?.provider_name,
      disabled: true,
      required: true,
      props: {
        autoFocus: true,
      },
      error: false,
    },
    {
      label: "Doctor Comp Plan",
      key: "comp_plan_type",
      placeHolder: "Doctor Comp Plan",
      componentType: 2,
      options: [
        "Net Production",
        "Gross Production",
        "Collections",
        "Flat Salary",
      ],
      originalValue: currentContract?.comp_plan_type,
      value: currentContract?.comp_plan_type,
      required: true,
      error: false,
    },
    {
      label: "Memo",
      key: "qbo_memo",
      type: "text",
      originalValue: currentContract?.qbo_memo,
      value: currentContract?.qbo_memo,
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "Compensation Account",
      key: "compensation_account",
      type: "text",
      originalValue: currentContract?.compensation_account,
      value: currentContract?.compensation_account,
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "Bonus Account",
      key: "bonus_account",
      type: "text",
      originalValue: currentContract?.bonus_account,
      value: currentContract?.bonus_account,
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: "",
      key: "_",
      type: "text",
      placeHolder: "",
      componentType: 0,
      value: "",
      required: false,
      error: false,
    },
    {
      label: "Comp Plan Start Date",
      key: "plan_start_date",
      originalValue: currentContract?.plan_start_date,
      value: currentContract?.plan_start_date,
      placeHolder: "",
      componentType: 3,
      required: true,
      error: false,
    },
    {
      label: "Comp Plan End Date",
      key: "plan_end_date",
      type: "text",
      originalValue: currentContract?.plan_end_date,
      value: currentContract?.plan_end_date,
      placeHolder: "",
      componentType: 3,
      required: true,
      error: false,
    },
    {
      label: "Guarantee",
      key: "guarantee_yes_no",
      placeHolder: "No",
      componentType: 2,
      required: true,
      originalValue: currentContract?.guarantee_yes_no,
      value: currentContract?.guarantee_yes_no,
      options: ["No", "Yes"],
      error: false,
    },
    {
      label: "Guarantee Type",
      key: "guarantee_type",
      placeHolder: "No",
      componentType: 2,
      required: guarantee ? true : false,
      originalValue: currentContract?.guarantee_type
        ? currentContract.guarantee_type
        : "Select guarantee type",
      value: currentContract?.guarantee_type
        ? currentContract.guarantee_type
        : "Select guarantee type",
      options: ["Daily", "Monthly"],
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee Start Date",
      key: "guarantee_start_date",
      type: "text",
      originalValue: currentContract?.guarantee_start_date
        ? currentContract.guarantee_start_date
        : "",
      value: currentContract?.guarantee_start_date
        ? currentContract.guarantee_start_date
        : "",
      placeHolder: "",
      componentType: 3,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee End Date",
      key: "guarantee_end_date",
      type: "text",
      originalValue: currentContract?.guarantee_end_date
        ? currentContract.guarantee_end_date
        : "",
      value: currentContract?.guarantee_end_date
        ? currentContract.guarantee_end_date
        : "",
      placeHolder: "",
      componentType: 3,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Guarantee $",
      key: "guarantee_amount",
      type: "text",
      originalValue: currentContract?.guarantee_amount
        ? currentContract.guarantee_amount
        : "0",
      value: currentContract?.guarantee_amount
        ? currentContract.guarantee_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: guarantee ? true : false,
      error: false,
      dependent: true,
    },
    {
      label: "Commission When Over Guarantee",
      key: "commission_over_guarantee_yes_no",
      placeHolder: "No",
      componentType: 2,
      required: guarantee ? true : false,
      originalValue: currentContract?.commission_over_guarantee_yes_no
        ? currentContract.commission_over_guarantee_yes_no
        : "No",
      value: currentContract?.commission_over_guarantee_yes_no
        ? currentContract.commission_over_guarantee_yes_no
        : "No",
      options: [`No`, `Yes`],
      error: false,
      dependent: true,
    },
    {
      label: "Lab %",
      key: "lab_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.lab_percent
        ? currentContract.lab_percent
        : "0",
      value: currentContract?.lab_percent ? currentContract.lab_percent : "0",
      required: true,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: "",
      key: "_",
      type: "text",
      placeHolder: "",
      componentType: -1,
      value: "",
      required: false,
      error: false,
    },
    {
      label: `Tier 1 %`,
      key: "tier_1_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.tier_1_comp_percent
        ? currentContract.tier_1_comp_percent
        : "0",
      value: currentContract?.tier_1_comp_percent
        ? currentContract.tier_1_comp_percent
        : "0",
      required: true,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 1 $`,
      key: "tier_1_comp_max_amount",
      type: "text",
      originalValue: currentContract?.tier_1_comp_max_amount
        ? currentContract.tier_1_comp_max_amount
        : "0",
      value: currentContract?.tier_1_comp_max_amount
        ? currentContract.tier_1_comp_max_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: true,
      error: false,
    },
    {
      label: `Tier 2 %`,
      key: "tier_2_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.tier_2_comp_percent
        ? currentContract.tier_2_comp_percent
        : "0",
      value: currentContract?.tier_2_comp_percent
        ? currentContract.tier_2_comp_percent
        : "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 2 $`,
      key: "tier_2_comp_max_amount",
      type: "text",
      originalValue: currentContract?.tier_2_comp_max_amount
        ? currentContract.tier_2_comp_max_amount
        : "0",
      value: currentContract?.tier_2_comp_max_amount
        ? currentContract.tier_2_comp_max_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 3 %`,
      key: "tier_3_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.tier_3_comp_percent
        ? currentContract.tier_3_comp_percent
        : "0",
      value: currentContract?.tier_3_comp_percent
        ? currentContract.tier_3_comp_percent
        : "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 3 $`,
      key: "tier_3_comp_max_amount",
      type: "text",
      originalValue: currentContract?.tier_3_comp_max_amount
        ? currentContract.tier_3_comp_max_amount
        : "0",
      value: currentContract?.tier_3_comp_max_amount
        ? currentContract.tier_3_comp_max_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 4 %`,
      key: "tier_4_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.tier_4_comp_percent
        ? currentContract.tier_4_comp_percent
        : "0",
      value: currentContract?.tier_4_comp_percent
        ? currentContract.tier_4_comp_percent
        : "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 4 $`,
      key: "tier_4_comp_max_amount",
      type: "text",
      originalValue: currentContract?.tier_4_comp_max_amount
        ? currentContract.tier_4_comp_max_amount
        : "0",
      value: currentContract?.tier_4_comp_max_amount
        ? currentContract.tier_4_comp_max_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
    {
      label: `Tier 5 %`,
      key: "tier_5_comp_percent",
      type: "number",
      placeHolder: "0 - 100",
      componentType: 1,
      originalValue: currentContract?.tier_5_comp_percent
        ? currentContract.tier_5_comp_percent
        : "0",
      value: currentContract?.tier_5_comp_percent
        ? currentContract.tier_5_comp_percent
        : "0",
      required: false,
      error: false,
      validation: {
        min: 0,
        max: 100,
      },
    },
    {
      label: `Tier 5 $`,
      key: "tier_5_comp_max_amount",
      type: "text",
      originalValue: currentContract?.tier_5_comp_max_amount
        ? currentContract.tier_5_comp_max_amount
        : "0",
      value: currentContract?.tier_5_comp_max_amount
        ? currentContract.tier_5_comp_max_amount
        : "0",
      placeHolder: "",
      componentType: 1,
      required: false,
      error: false,
    },
  ]

  const [loading, setLoading] = useState<boolean>(false)
  const [formState, setformState] = useState(formFields)
  const [guaranteeStartDate, setGuaranteeStartDate] = useState<any>(null)
  const [guaranteeEndDate, setGuaranteeEndDate] = useState<any>(null)

  useEffect(() => {
    setGuaranteeStartDate(
      formState?.find((f: formType) => f.key == "plan_start_date")?.value,
    )
    setGuaranteeEndDate(
      formState?.find((f: formType) => f.key == "plan_end_date")?.value,
    )
  }, [formState])

  const submitHandler = async () => {
    let newFormState: formType[] = [...formState]
    let failed = false
    let guarantee_value: any = ""
    // Comp Plan - Guarantee Validation
    formState.forEach((field: formType) => {
      if (field.key == "guarantee_yes_no") {
        guarantee_value = field.value || ""
      }
    })

    formState.forEach((field: formType) => {
      if (field.key == "guarantee_yes_no") {
        const compPlanType = formState.find(
          (f: formType) => f?.key == "comp_plan_type",
        )

        if (compPlanType?.value == "Flat Salary" && !guarantee) {
          field.error = true
          field.errorMessage =
            "Guarantee must be Yes as Comp plan type is Flat Salary"
          failed = true
        } else {
          field.error = false
        }
      }
      if (field.key == "guarantee_amount") {
        if (guarantee_value == "Yes" && Number(field.value || 0) <= 0) {
          field.error = true
          field.errorMessage = "Guarantee amount must be greater than 0"
          failed = true
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Commission Over Guarantee - Tier 1 Validation

    formState.forEach((field: formType) => {
      if (
        field.key == "tier_1_comp_max_amount" ||
        field.key == "tier_1_comp_percent"
      ) {
        const commissionOverGuarantee = formState.find(
          (f: formType) => f?.key == "commission_over_guarantee_yes_no",
        )

        const fieldValue =
          field.key == "tier_1_comp_max_amount" &&
          field.value != null &&
          typeof field.value != "number"
            ? (parseFloat(field.value) as number)
            : (field.value as number)

        if (commissionOverGuarantee?.value == "Yes" && fieldValue <= 0) {
          field.error = true
          field.errorMessage =
            "Commission Over Guarantee is Yes, Tier 1 Values must be greater than 0"
          failed = true
        } else {
          field.error = false
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Guarantee Validation

    formState.forEach((field: formType) => {
      if (field.label.includes("Guarantee") && guarantee) {
        if (!field.value) {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        } else {
          field.error = false
        }
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Default Selected Validation

    formState.forEach((field: formType) => {
      const fieldValue = field.value as string

      if (fieldValue.includes("Select")) {
        if (!guarantee && field.label.includes("Guarantee")) {
          field.error = false
        } else {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        }
      } else {
        field.error = false
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Required Validation

    formState.forEach((field: formType) => {
      if (field.required && !field.value) {
        console.log("l1", field)

        if (!guarantee && field.label.includes("Guarantee")) {
          console.log("l2", guarantee)

          field.error = false
        } else {
          field.error = true
          field.errorMessage = "Field is required"
          failed = true
        }
      } else {
        field.error = false
      }
    })

    if (failed) {
      return setformState(newFormState)
    }

    // Number Range Validation

    newFormState.forEach((field) => {
      if (field.validation) {
        const fieldValue = field.value as number
        if (
          fieldValue < field.validation.min ||
          fieldValue > field.validation.max
        ) {
          failed = true
          field.error = true
          field.errorMessage = `Value should in between ${field.validation.min} and ${field.validation.max}`
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    // Date Validation
    let planStartDate = dayjs()
    let planEndDate = dayjs()
    let guaranteeStartDate = dayjs()
    let guaranteeEndDate = dayjs()

    newFormState.forEach((field) => {
      if (field.key == "plan_start_date") {
        planStartDate = dayjs(field.value)
      }
      if (field.key == "plan_end_date") {
        planEndDate = dayjs(field.value)
      }
      if (field.key == "guarantee_start_date") {
        guaranteeStartDate = dayjs(field.value)
      }
      if (field.key == "guarantee_end_date") {
        guaranteeEndDate = dayjs(field.value)
      }
    })

    newFormState.forEach((field) => {
      if (field.key == "plan_start_date" && planStartDate > planEndDate) {
        failed = true
        field.error = true
        field.errorMessage = `Start date can not exceed End Date`
      }
      if (
        field.key == "guarantee_start_date" &&
        guaranteeStartDate > guaranteeEndDate
      ) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `Start date can not exceed End Date`
        }
      }
      if (
        field.key == "guarantee_start_date" &&
        guaranteeStartDate < planStartDate
      ) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `Start date can not be less than Plan Start Date`
        }
      }
      if (field.key == "guarantee_end_date" && guaranteeEndDate > planEndDate) {
        if (guarantee) {
          failed = true
          field.error = true
          field.errorMessage = `End date can not be more than Plan End Date`
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    // Tier Validation
    newFormState.forEach((field, index) => {
      if (field.label.includes("Tier") && field.label.includes("$")) {
        const fieldValue = field.value as string
        const fieldNumber = field.label.split(" ")[1]

        if (parseInt(fieldNumber) > 1) {
          if (
            parseInt(fieldValue) > 0 &&
            parseInt(fieldValue) <
              parseInt(newFormState[index - 2].value as string)
          ) {
            failed = true
            field.error = true
            field.errorMessage = `Value should be larger than Tier ${
              parseInt(fieldNumber) - 1
            } $`
          }
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    setformState(newFormState)
    let payload: any = {}
    newFormState.forEach((field) => {
      const fieldName = field.key
        ? field.key
        : field.label.replaceAll(" ", "_").toLowerCase()
      if (field?.originalValue != field?.value) {
        if (!field.dependent) {
          payload[fieldName] = field?.value
        } else {
          if (guarantee) payload[fieldName] = field?.value
        }
      }
    })
    const cleanUpHandler = (loadVal: boolean) => {
      if (!loadVal) {
        setformState([...formFields])
        setLoading(loadVal)
        setGuarantee(false)
        closeHandler()
        return
      }
      return setLoading(loadVal)
    }
    console.log("payload", payload)

    await updateHandler(payload, cleanUpHandler)
  }

  const clearAndClose = () => {
    setformState(formFields)
    setGuarantee(false)
    closeHandler()
  }

  const fieldHandler = (e: any, index: number, ops?: any) => {
    if (ops?.componentType == 3) {
      const newState = [...formState]
      newState[index].value = e
      setformState(newState)
    } else {
      e.preventDefault()

      if (index == 8) {
        if (e.target.value == "Yes") setGuarantee(true)
        else setGuarantee(false)
      }

      const newState = [...formState]
      newState[index].value = e.target.value
      setformState(newState)
    }
  }

  const renderGrid = (ops: any, index: number) => {
    if (ops.componentType === 0) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Box></Box>
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === -1 && guarantee) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Box></Box>
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 1) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <TextField
            error={ops.error}
            key={ops.label}
            value={ops.value}
            onChange={(e) => fieldHandler(e, index)}
            required={ops?.required}
            placeholder={ops?.placeHolder}
            type={ops?.type}
            fullWidth
            variant="outlined"
            disabled={reconciled}
          />
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 2) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <Select
            key={ops.label}
            type={ops?.type}
            error={ops.error}
            onChange={(e) => fieldHandler(e, index)}
            fullWidth
            IconComponent={ExpandMoreIcon}
            value={ops.value ? ops.value : "Error"}
            renderValue={() => (ops.value ? ops.value : "Error")}
            disabled={ops.disabled || reconciled}
            MenuProps={{
              sx: {
                px: 1,
              },
            }}
            variant="outlined"
          >
            {ops?.options?.map((option: any) => {
              return (
                <MenuItem
                  value={option}
                  sx={{
                    fontWeight: "bold",
                    m: 1,
                    borderRadius: "5px",
                    textAlign: "center",
                  }}
                >
                  {option}
                </MenuItem>
              )
            })}
          </Select>
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    } else if (ops.componentType === 3) {
      return (
        <Grid item xs={6} key={ops.label}>
          <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
            {ops.label} {ops.required && " *"}
          </Typography>
          <ReusableDatePicker
            fieldHandler={fieldHandler}
            index={index}
            ops={ops}
            defaultValue={ops.value ? dayjs(ops.value) : ops.value}
            disabled={reconciled}
            startDate={guaranteeStartDate}
            EndDate={guaranteeEndDate}
            formKey={ops.key}
          />
          {ops.error && (
            <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
              {ops?.errorMessage}
            </Typography>
          )}
        </Grid>
      )
    }

    return null
  }

  // useEffect(() => {}, [guarantee, formState, doctorList])

  useEffect(() => {
    setformState(formFields)
    setReconciled(currentContract?.is_reconciled)
    setGuarantee(
      currentContract?.guarantee_yes_no
        ? currentContract?.guarantee_yes_no == "No"
          ? false
          : true
        : false,
    )
  }, [currentContract])

  return (
    <Dialog open={open} maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          my: 1,
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", pl: 2 }}>
          Edit contract
        </Typography>
        <IconButton sx={{ mr: 1 }} onClick={clearAndClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Grid container spacing={1.5} sx={{ px: 2, pb: 2 }}>
        {formState.map((ops: formType, index: number) => {
          if (ops.dependent) {
            if (guarantee) {
              return renderGrid(ops, index)
            } else return null
          } else {
            return renderGrid(ops, index)
          }
        })}
      </Grid>
      <Box sx={{ display: "flex", flex: 1, columnGap: 1, mb: 2, mx: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={clearAndClose}
          sx={{ py: 1 }}
        >
          Cancel
        </Button>
        <Button
          endIcon={
            loading && <CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
          }
          variant="contained"
          fullWidth
          onClick={submitHandler}
          sx={{ py: 1 }}
        >
          {loading ? "Updating contract" : "Update contract"}
        </Button>
      </Box>
    </Dialog>
  )
}
